import { useEffect, useState } from 'react';
import { adminApi } from './api';

// Tarif keys (BASIC, BASICPLUS, ...) are internal. Show the names from the tariff catalog; fall back to the key.
// F-23 (PF-NB-geld-2, SPEC-geld Befund 4): dazu der Tarif der eigenen Firma (eigener), auch wenn er nicht veröffentlicht ist.
let request: Promise<Record<string, string>> | null = null;
function loadPlanNames() {
  request ??= adminApi.get<{ plans: { key: string; name: string }[]; eigener?: { key: string; name: string } | null }>('/billing/plans')
    .then(result => Object.fromEntries([...(result.eigener ? [result.eigener] : []), ...result.plans].map(plan => [plan.key, plan.name])))
    .catch(() => { request = null; return {}; });
  return request;
}
export function planName(names: Record<string, string>, key: string | null | undefined) {
  if (!key) return '—';
  return names[key] || key;
}
export function usePlanNames() {
  const [names, setNames] = useState<Record<string, string>>({});
  useEffect(() => { let alive = true; void loadPlanNames().then(value => { if (alive) setNames(value); }); return () => { alive = false; }; }, []);
  return (key: string | null | undefined) => planName(names, key);
}
